import { adminCompanyRoutes } from "routes/admin.company.routes"
import { adminGuestRoutes } from "routes/admin.guest.routes"
import { adminProductRoutes } from "routes/admin.product.routes"
import { adminUserRoutes } from "routes/admin.user.routes"
import { Redirect } from "react-router"
import { myLazy } from "utils/myLazy"
import { GooglePageViewTypes } from "utils/googleAnalytics/googleAnalyticsPageViewEvent"


export const adminRoutes = [
  /// sub paths
  {
    path: "/admin/user",
    routes: adminUserRoutes
  },
  {
    path: "/admin/company",
    routes: adminCompanyRoutes
  },
  {
    path: "/admin/guest",
    routes: adminGuestRoutes
  },
  {
    path: "/admin/product",
    routes: adminProductRoutes
  },

  //===================================================================
  // 5.0 Orders
  {
    exact: true,
    path: "/admin/maintenance",
    component: myLazy(() =>
      import("../views/admin/startAndStopMaintenance/startAndStopMaintenance")
    ),
    googleAnalyticsPageType: GooglePageViewTypes.CONTENT,
    pageTitle: "Mentenanță"
  },
  {
    exact: true,
    path: "/admin/order/list",
    component: myLazy(() => import("../views/admin/order/List")),
    googleAnalyticsPageType: GooglePageViewTypes.PRODUCT_LISTING,
    pageTitle: "Listă comenzi"
  },
  {
    exact: true,
    path: "/admin/order/view",
    component: myLazy(() => import("../views/admin/orderDetails/orderDetails")),
    googleAnalyticsPageType: GooglePageViewTypes.PRODUCT,
    pageTitle: "Detalii comandă"
  },
  {
    exact: true,
    path: "/admin/order/invoice/list",
    component: myLazy(() => import("../views/admin/invoice/List")),
    googleAnalyticsPageType: GooglePageViewTypes.PRODUCT_LISTING,
    pageTitle: "Listă facturi"
  },
  {
    exact: true,
    path: "/admin/order/invoice/form",
    component: myLazy(() => import("../views/admin/invoice/form/InvoiceDetails")),
    googleAnalyticsPageType: GooglePageViewTypes.PRODUCT,
    pageTitle: "Detalii factură"
  },
  //missing invoice view
  {
    exact: false,
    path: "/admin/order",
    component: myLazy(() => import("../views/admin/unifiedDashboard")),
    googleAnalyticsPageType: GooglePageViewTypes.HOME,
    pageTitle: "Comenzi și facturi"
  },
  //===================================================================
  //6.0 Liste predefinite
  {
    exact: true,
    path: "/admin/admin-lists/list",
    component: myLazy(() => import("../views/admin/listePredefinite/List")),
    googleAnalyticsPageType: GooglePageViewTypes.PRODUCT_LISTING,
    pageTitle: "Lista generală cu liste predefinite"
  },
  {
    exact: false,
    path: "/admin/admin-lists/form",
    component: myLazy(() => import("views/admin/listePredefinite/addList")),
    googleAnalyticsPageType: GooglePageViewTypes.PRODUCT,
    pageTitle: "Formular listă predefinită"
  },
  {
    exact: true,
    path: "/admin/admin-lists/dashboard",
    component: myLazy(() => import("../views/admin/unifiedDashboard")),
    googleAnalyticsPageType: GooglePageViewTypes.HOME,
    pageTitle: "Liste predefinite"
  },
  {
    exact: false,
    path: "/admin/admin-lists",
    component: () => <Redirect to="/admin/admin-lists/dashboard" />
  },
  //===================================================================
  // 8.1 Depozite
  // {
  //   exact: true,
  //   path: '/admin/warehouse/list',
  //   component: myLazy(() =>
  //     import('../views/admin/depoziteUniprest/depoziteUniprest')
  //   )
  // },
  // {
  //   exact: false,
  //   path: '/admin/warehouse/details',
  //   component: myLazy(() => import('../views/admin/product/warehouseDetails'))
  // },

  //===================================================================
  // ########## Next Module ##############
  {
    exact: true,
    path: "/admin/oferte/list",
    component: myLazy(() => import("../views/admin/oferte/oferteTable")), // DONE
    googleAnalyticsPageType: GooglePageViewTypes.PRODUCT_LISTING,
    pageTitle: "Listă oferte"
  },
  {
    exact: true,
    path: "/admin/offer/list",
    component: myLazy(() => import("../views/admin/offer/List")),
    googleAnalyticsPageType: GooglePageViewTypes.PRODUCT_LISTING,
    pageTitle: "Listă oferte"
  },
  // // //proiecte
  {
    exact: true,
    path: "/admin/project/",
    component: myLazy(() => import("../views/admin/project/Dashboard")),
    googleAnalyticsPageType: GooglePageViewTypes.HOME,
    pageTitle: "Proiecte"
  },
  {
    exact: true,
    path: "/admin/project/list",
    component: myLazy(() => import("../views/admin/project/List")),
    googleAnalyticsPageType: GooglePageViewTypes.PRODUCT_LISTING,
    pageTitle: "Listă proiecte"
  },

  //===================================================================
  {
    exact: false,
    path: "/admin",
    component: myLazy(() => import("../views/admin/unifiedDashboard")),
    googleAnalyticsPageType: GooglePageViewTypes.HOME,
    pageTitle: "Dashboard"
  }
]

// // //joburi
// {
//   exact: true,
//   path: "/admin/jobs/",
//   component: myLazy(() => import("./views/admin/jobs/jobs"))
// },
// // //pagini prezentare
// {
//   exact: true,
//   path: "/admin/pages/",
//   component: myLazy(() => import("./views/admin/pages/pages"))
// },
// // //promotii
// {
//   exact: true,
//   path: "/admin/promo/",
//   component: myLazy(() => import("./views/admin/promotions/promotions"))
// },
// // //parametrizari
// {
//   exact: true,
//   path: "/admin/parameters/",
//   component: myLazy(() => import("./views/admin/parametrizari/parametrizari"))
// },
// // //setari
// {
//   exact: true,
//   path: "/admin/settings/",
//   component: myLazy(() => import("./views/admin/settings/settings"))
// },
